import Appsignal from "@appsignal/javascript"; // For ES Module

// Get appsignal environment variable
const appsignalToken =
  document.querySelector("meta[name='appsignal-frontend-token']")?.content ||
  "";

export const appsignal = new Appsignal({
  key: appsignalToken,
});
